import React, { useState } from 'react';
import { parse, isBefore, isAfter, isSameDay } from 'date-fns';
import { AccessibleForm, Collapse, Row, InputMessage, Button, Col, Box, themes, NewDateInput } from '@digitools/honest-react';
import LanguageToggle from 'src/utils/LanguageToggle';
const PaymentFilter = ({ initialData, setFilteredData }) => {
    const [dateRangeError, setDateRangeError] = useState();
    const [formApi, setFormApi] = useState();
    if (!initialData) {
        return null; // don't display filter for no data
    }
    const filterPaymentsByDate = (values) => {
        const fromDate = parse(values.fromDate, 'MM/dd/yyyy', new Date());
        const throughDate = parse(values.throughDate, 'MM/dd/yyyy', new Date());
        const filteredDate = initialData.filter((data) => {
            const checkDate = parse(data.checkDate, 'MM/dd/yyyy', new Date());
            return (isBefore(fromDate, checkDate) || isSameDay(fromDate, checkDate)) && (isBefore(checkDate, throughDate) || isSameDay(checkDate, throughDate));
        });
        setFilteredData(filteredDate);
    };
    const validateDateFilter = (values) => {
        const fromDate = parse(values.fromDate, 'MM/dd/yyyy', new Date());
        const throughDate = parse(values.throughDate, 'MM/dd/yyyy', new Date());
        if (isAfter(fromDate, throughDate)) {
            setDateRangeError(true);
            return <LanguageToggle en='From date must come before through date' es='La fecha desde debe ser anterior a la fecha hasta'/>;
        }
    };
    const clearFilterForm = () => {
        // clear out the values form the form
        formApi.setValue('fromDate', undefined);
        formApi.setValue('throughDate', undefined);
        formApi.setError('fromDate', undefined);
        formApi.setError('throughDate', undefined);
        setDateRangeError(false);
        setFilteredData(undefined);
    };
    return (<Box data-testid='payment-filter-box' style={{ border: `1px solid ${themes.rebrand.palette.grayLighter}` }}>
      <Collapse title={'Filter'} data-testid='filterPaymentsHeader' type={'alternate'} theme={themes.rebrand}>
        <AccessibleForm onSubmit={filterPaymentsByDate} getApi={setFormApi} validate={validateDateFilter}>
          <Row>
            <Col md={6} sm={12}>
              <NewDateInput data-testid={'filterFromDate'} style={{ width: '50%' }} field={'fromDate'} ariaLabelText={'From Date'} label={'From Date'} required={true}/>
            </Col>
            <Col md={6} sm={12}>
              <NewDateInput data-testid={'filterThroughDate'} field={'throughDate'} ariaLabelText={'Through Date'} label={'Through Date'} required={true}/>
            </Col>
          </Row>
          {dateRangeError && <InputMessage data-testid="date-range-error" error={true}>{formApi && formApi.getState().error}</InputMessage>}
          <Row>
            <Button data-testid={'filterClearButton'} type='button' buttonType={'secondary'} onClick={() => clearFilterForm()} style={{ marginLeft: 'auto' }}>
              Clear filter
            </Button>
            <Button data-testid="applyFilterButton" type='submit' buttonType={'primary'} style={{ marginLeft: '1rem' }}>
              Apply
            </Button>
          </Row>
        </AccessibleForm>
      </Collapse>
    </Box>);
};
export default PaymentFilter;
